export class JSONUtil {
    static unflatten(data: any) {
        'use strict';
        if (Object(data) !== data || Array.isArray(data)) {
            return data;
        }
        const result: any = {};
        let cur: any;
        let prop: any;
        let parts;
        let idx;
        // tslint:disable-next-line:forin
        for (const p in data) {
            cur = result;
            prop = '';
            parts = p.split('.');
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < parts.length; i++) {
                idx = !isNaN(parseInt(parts[i], 10));
                cur = cur[prop] || (cur[prop] = (idx ? [] : {}));
                prop = parts[i];
            }
            cur[prop] = data[p];
        }
        return result[''];
    }

    static flatten(data: any) {
        const result: any = {};

        function recurse(cur: any, prop: any) {
            if (Object(cur) !== cur) {
                result[prop] = cur;
            } else if (Array.isArray(cur) && typeof cur !== 'string') {
                console.log('cur==array', cur, typeof cur);
                for (let i = 0, l = cur.length; i < l; i++) {
                    recurse(cur[i], prop ? prop + '[' + i + ']' : '' + i);
                    if (l === 0) {
                        result[prop] = [];
                    }
                }
            } else {
                let isEmpty: boolean = true;
                // tslint:disable-next-line:forin
                for (const p in cur) {
                    isEmpty = false;
                    recurse(cur[p], prop ? prop + '.' + p : p);
                }
                if (isEmpty) {
                    result[prop] = {};
                }
            }
        }

        recurse(data, '');
        return result;
    }
}
